export default __webpack_public_path__ + "static/media/trybook3.64ece0f5.png";